/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { Keyboard, A11y } from 'swiper/modules';
import { Swiper } from 'swiper/react';

import { CarouselContainer } from './styles';

const Carousel = ({ children, breakpoints, modules = [], ...rest }) => {
  const defaultModules = [Keyboard, A11y];

  return (
    <CarouselContainer>
      <Swiper
        tabIndex="0"
        breakpoints={breakpoints}
        a11y={{
          slideRole: 'group',
          enabled: true,
        }}
        allowTouchMove
        keyboard
        modules={[...defaultModules, ...modules]}
        {...rest}
      >
        {children}
      </Swiper>
    </CarouselContainer>
  );
};

Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  breakpoints: PropTypes.shape().isRequired,
  modules: PropTypes.arrayOf(PropTypes.func),
};

export default Carousel;
